import { ReactNode } from 'react';

import { Box, Stack, tokens } from '@cast/design-system';

type ConnectionChoiceIconProps = {
  children: ReactNode;
};

export const ConnectionChoiceIcon = ({
  children,
}: ConnectionChoiceIconProps) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{
      width: 44,
      height: 44,
      borderRadius: '16px',
      backgroundColor: tokens.theme.bg.structural.surfaceRaised,
      flexShrink: 0,
      color: tokens.theme.fg.structural.secondary,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
          width: 22,
          height: 22,
        },
      }}
    >
      {children}
    </Box>
  </Stack>
);
